import URLS from '@/server/urls';
import { GET } from '@/server/http';

export default async ({
    len = 30,
}, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.common.randomStr, {
        len,
    }, options);
    if (error) return { error, status };
    return content || { value: '' };
};
